import React from 'react';

type Props = {
	width: number;
	height: number;
	className?: string;
};

export const EmailIcon = ({ width = 24, height = 24, className }: Props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		className={className}
		viewBox="0 0 256 256"
		fill="none"
		id="my-svg"
	>
		<defs>
			<linearGradient id="gradient1">
				<stop className="stop1" offset="0%" stopColor="none" />
				<stop className="stop2" offset="100%" stopColor="none" />
			</linearGradient>
		</defs>
		<rect id="backgr" width={256} height={256} fill="none" rx={60} />
		<path
			d="M32 74.667c0 -10.667 10.667 -21.333 21.333 -21.333h149.333c10.667 0 21.333 10.667 21.333 21.333M32 74.667v106.667c0 5.035 2.379 10.069 6.016 13.984M32 74.667l67.765 45.173M224 74.667v106.667c0 5.035 -2.379 10.069 -6.016 13.984M224 74.667l-67.765 45.173m61.76 75.477c-4.064 4.373 -9.707 7.349 -15.328 7.349H53.333c-5.632 0 -11.264 -2.976 -15.317 -7.349m179.968 0 -61.749 -75.477M38.016 195.317l61.749 -75.477m0 0 4.565 3.051a42.667 42.667 0 0 0 47.339 0l4.565 -3.051"
			stroke="currentColor"
			strokeWidth={14}
			strokeLinecap="round"
			strokeLinejoin="round"
			id="my-path"
			transform="translate(0,0) scale(1)"
		/>
	</svg>
);
